<template>
<a-layout-content style="margin: 20px">
  <a-tabs defaultActiveKey="1" :size="size">
    <a-tab-pane tab="Update Profile" key="1">
      <a-update-profile />
    </a-tab-pane>
    <a-tab-pane tab="Change Password" key="2">
      <a-change-password />
    </a-tab-pane>
    <a-tab-pane tab="MFA Authenticators" key="3">
      <a-mfa-authenticator />
    </a-tab-pane>
  </a-tabs>
</a-layout-content>
</template>

<script>
import AUpdateProfile from '@/components/UserSettings/AUpdateProfile.vue';
import AChangePassword from '@/components/UserSettings/AChangePassword.vue';
import AMfaAuthenticator from '@/components/UserSettings/AMfaAuthenticator.vue';

export default {
  data() {
    return {
      size: 'large'
    }
  },
  components: {
    AUpdateProfile,
    AChangePassword,
    AMfaAuthenticator
  }
}
</script>

<style>

</style>
